import { Outlet, NavLink } from "react-router-dom"
import {
  Container,
  Box,
  Toolbar,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  ListSubheader,
} from "@mui/material"
import HomeIcon from "@mui/icons-material/Home"
import {
  eventReports,
  organizationReports,
  userReports,
} from "../constants/reportPages"
import AppBarComponent from "./AppBarComponent"

const DRAWER_WIDTH = 240

function AppLayout() {
  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <AppBarComponent />

      <Drawer
        variant="permanent"
        sx={{
          width: DRAWER_WIDTH,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: DRAWER_WIDTH,
            boxSizing: "border-box",
          },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: "auto" }}>
          <Divider />
          <List>
            <ListItem disablePadding>
              <ListItemButton
                component={NavLink}
                to="/"
                end
                sx={{
                  "&.active": {
                    backgroundColor: "action.selected",
                  },
                }}
              >
                <ListItemIcon sx={{ minWidth: 0, mr: 2 }}>
                  <HomeIcon />
                </ListItemIcon>
                <ListItemText primary="Home" />
              </ListItemButton>
            </ListItem>

            <ListSubheader>Organization</ListSubheader>
            {organizationReports.map((page) => (
              <ListItem key={page.path} disablePadding>
                <ListItemButton
                  component={NavLink}
                  to={page.path}
                  sx={{
                    "&.active": {
                      backgroundColor: "action.selected",
                    },
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 0, mr: 2 }}>
                    <page.icon />
                  </ListItemIcon>
                  <ListItemText primary={page.title} />
                </ListItemButton>
              </ListItem>
            ))}

            <ListSubheader>Events</ListSubheader>
            {eventReports.map((page) => (
              <ListItem key={page.path} disablePadding>
                <ListItemButton
                  component={NavLink}
                  to={page.path}
                  sx={{
                    "&.active": {
                      backgroundColor: "action.selected",
                    },
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 0, mr: 2 }}>
                    <page.icon />
                  </ListItemIcon>
                  <ListItemText primary={page.title} />
                </ListItemButton>
              </ListItem>
            ))}

            <ListSubheader>User Reports</ListSubheader>
            {userReports.map((page) => (
              <ListItem key={page.path} disablePadding>
                <ListItemButton
                  component={NavLink}
                  to={page.path}
                  sx={{
                    "&.active": {
                      backgroundColor: "action.selected",
                    },
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 0, mr: 2 }}>
                    <page.icon />
                  </ListItemIcon>
                  <ListItemText primary={page.title} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Toolbar />
        <Container
          sx={{
            marginBlock: 4,
            width: "100%",
            minWidth: 0,
          }}
          maxWidth="xl"
        >
          <Outlet />
        </Container>
      </Box>
    </Box>
  )
}

export default AppLayout
